import { CiLogout } from "react-icons/ci";
import { IoReturnDownBackSharp } from "react-icons/io5";
import { FaDiagramNext, FaGear } from "react-icons/fa6";
import { IoMdRefresh } from "react-icons/io";
import { FcGoogle } from "react-icons/fc";
import { GoHomeFill } from "react-icons/go";
import { LuMenu } from "react-icons/lu";

import ic from "./Icons.module.scss";

// switch function get the icon
export function getIcon(iconName: string) {
  switch (iconName) {
    case "logoutIcon":
      return <CiLogout className={ic.logout_icon} />;
    case "returnIcon":
      return <IoReturnDownBackSharp className={ic.return_icon} />;
    case "nextIcon":
      return <FaDiagramNext className={ic.next_icon} />;
    case "refreshIcon":
      return <IoMdRefresh className={ic.refresh_icon} />;
    case "googleIcon":
      return <FcGoogle className={ic.google_icon} />;
    case "homeIcon":
      return <GoHomeFill className={ic.home_icon} />;
    case "gearIcon":
      return <FaGear className={ic.gear_icon} />;
    case "menuIcon":
      return <LuMenu className={ic.menu_icon} />;

    default:
      break;
  }
}
